module.exports = __webpack_public_path__ + "img/praise_green.7fcad8bd.png";